import React from "react";
import { Box, Typography } from "@mui/material";
import FDialog from "@ui/components/dialog/FDialog";
import { SignalMeter } from "@ui/components/icons/SignalMeter";
export const RemoveAPDialog = ({ isOpen, onClose, onConfirm, accessPoint, userName, loading = false, }) => {
    return (React.createElement(FDialog, { isOpen: isOpen, onClose: onClose, onSubmit: onConfirm, title: "Remove Access Point", confirmText: loading ? "Removing..." : "Remove", cancelText: "Cancel", maxWidth: "sm" },
        React.createElement(Box, { sx: { mb: 3 } },
            React.createElement(Typography, { variant: "body1", color: "text.secondary" },
                "Are you sure you want to remove this Access Point from",
                " ",
                userName ? React.createElement("strong", null, userName) : "this user",
                "?"),
            React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mt: 1 } }, "This will remove the user as an administrator from this Access Point."),
            accessPoint && (React.createElement(Box, { sx: {
                    mt: 2,
                    p: 2.5,
                    border: "1px solid #DFE3E8",
                    borderRadius: 4,
                    backgroundColor: "#FFFFFF",
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                } },
                React.createElement(SignalMeter, { width: 50, height: 40 }),
                React.createElement(Box, { sx: { flex: 1 } },
                    React.createElement(Typography, { variant: "subtitle1", fontWeight: 600 }, accessPoint.name),
                    React.createElement(Typography, { variant: "body2", color: "text.secondary" }, accessPoint.deviceId)))))));
};
